import { parseISO } from "date-fns";
const toInvitee = (raw) => {
  if (!raw) {
    return void 0;
  }
  return {
    firstName: raw.firstName,
    lastName: raw.lastName ?? void 0,
    email: raw.email ?? void 0,
    phone: raw.phone ?? void 0
  };
};
const toChild = (raw) => {
  if (!raw) {
    return void 0;
  }
  return {
    firstName: raw.firstName,
    lastName: raw.lastName ?? void 0
  };
};
const toStore = (raw) => {
  if (!raw) {
    return null;
  }
  return {
    name: raw.name,
    code: raw.code.toString(),
    globalStoreId: raw.globalStoreId ?? raw.code.toString(),
    phone: raw.phone ?? null,
    streetName: raw.streetName,
    streetNumber: raw.streetNumber ?? void 0,
    town: raw.town,
    postalCode: raw.postalCode ?? void 0,
    country: raw.country,
    lat: raw.lat ?? void 0,
    lon: raw.lon ?? void 0
  };
};
const toAppointmentType = (raw) => {
  if (!raw) {
    return null;
  }
  return {
    name: raw.name,
    label: raw.label,
    description: raw.description,
    duration: raw.duration
  };
};
const toAppointmentTypeDetails = (raw) => {
  if (!raw) {
    return null;
  }
  return {
    id: raw.id,
    name: raw.name,
    description: raw.description,
    ageGroup: raw.ageGroup
  };
};
const toAppointment = (raw) => {
  if (!raw) {
    return null;
  }
  return {
    id: raw.id,
    appointmentType: toAppointmentTypeDetails(raw.appointmentType) ?? void 0,
    invitee: toInvitee(raw.invitee) ?? void 0,
    child: toChild(raw.child) ?? void 0,
    isCancellable: raw.isCancellable,
    isReschedulable: raw.isReschedulable,
    isReservation: raw.isReservation ?? void 0,
    endTime: parseISO(raw.endTime),
    startTime: parseISO(raw.startTime),
    store: toStore(raw.storeInfo) ?? void 0,
    customerComment: raw.customerComment ?? void 0
  };
};
const toAppointments = (raw) => raw?.map((rawAppointment) => ({
  id: rawAppointment.id,
  customerComment: rawAppointment.customerComment ?? void 0,
  appointmentType: toAppointmentType(rawAppointment.appointmentType) ?? void 0,
  invitee: toInvitee(rawAppointment.invitee) ?? void 0,
  isReservation: rawAppointment.isReservation ?? void 0,
  endTime: parseISO(rawAppointment.endTime),
  startTime: parseISO(rawAppointment.startTime),
  store: toStore(rawAppointment.storeInfo) ?? void 0,
  isVirtualAppointment: rawAppointment.isVirtualAppointment ?? false,
  child: toChild(rawAppointment.child) ?? void 0
})) ?? null;
export {
  toAppointment,
  toAppointments
};
//# sourceMappingURL=appointment.js.map
